import styled from 'styled-components'

export const CodeBoxButtonWrapper = styled.div`
  cursor: pointer;

  &:hover {
    color: var(--primary4);
  }
`
